module.exports = __webpack_public_path__ + "img/vizualPR.440d8b49.png";